import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Input from "../../Components/shared/Input";
import { fetchData, fetchFormData } from "../../utils/options";
import topTost from "../../utils/topTost";

const RoleCreate = ({ permission }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");
  const [role, setRole] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const fetchDetails = async (id) => {
    try {
      const result = await fetchData(`role/${id}`, {}, "GET");

      if (result && result.role) {
        setRole(result.role.role);
      } else {
        console.warn("State data not found.");
        setRole("");
      }
    } catch (error) {
      console.error("Failed to fetch user details:", error);
      setRole("");
    }
  };

  useEffect(() => {
    if (id) {
      fetchDetails(id);
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const formData = new FormData();
    formData.append("created_by", userId);
    formData.append("moduleId", M_id);
    formData.append("role", role);

    try {
      let res;

      if (id) {
        formData.append("id", id);
        formData.append("userId", userId);
        // Edit logic - update role
        res = await fetchFormData("role/update", formData, "POST");
        console.log("Updating role:", id, formData);
      } else {
        // Create logic - new role
        res = await fetchFormData("role/create", formData, "POST");
        console.log("Creating new role:", formData);
      }

      if (res && res.code === 200) {
        topTost({
          title: res.message,
          icon: "success",
        });
        navigate(`/master/role-list?id=${M_id}`);
        console.log("Role operation successful", res);
      } else {
        console.error("Role operation failed", res);
      }
    } catch (error) {
      console.error("Submit error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="col-lg-12">
        <div className="card stretch stretch-full">
          <hr className="mt-0" />
          <div className="card-body general-info">
            <div className="mb-5 d-flex align-items-center justify-content-between">
              <h5 className="fw-bold mb-0 me-4">
                <span className="d-block mb-2">
                  {id ? "Edit Role:" : "Add Role:"}
                </span>
              </h5>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <Input
                    icon="feather-briefcase"
                    label="Role"
                    labelId="roleInput"
                    placeholder="Role"
                    name="role"
                    value={role}
                    required
                    onChange={(name, value) => setRole(value)}
                  />
                </div>
                <div className="col-md-6">
                  <button
                    type="submit"
                    className="btn btn-lg btn-primary"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Submitting..." : id ? "Update" : "Submit"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default RoleCreate;
